import { render, staticRenderFns } from "./Resumos.vue?vue&type=template&id=71b573c3&scoped=true&"
import script from "./Resumos.vue?vue&type=script&lang=js&"
export * from "./Resumos.vue?vue&type=script&lang=js&"
import style0 from "./Resumos.vue?vue&type=style&index=0&id=71b573c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b573c3",
  null
  
)

export default component.exports